import { Link, useLocation } from 'react-router-dom';
import { LayoutDashboard, BookOpen, Activity, ClipboardCheck, Shield, Settings2, ClipboardList, Stamp, Users, Building2, ShieldAlert, CalendarDays } from 'lucide-react';
import { SECTIONS } from '../lib/sectionTheme';
import { useAuth } from '../context/AuthContext';

const tabs = [
  { ...SECTIONS.dashboard, icon: LayoutDashboard, paths: ['/'], href: '/' },
  { ...SECTIONS.training,  icon: BookOpen,        paths: ['/k4', '/module', '/search', '/chat', '/quick-ref'], href: '/k4' },
  { ...SECTIONS.mbs,       icon: Activity,        paths: ['/mbs'], href: '/mbs' },
  { ...SECTIONS.sops,      icon: ClipboardCheck,  paths: ['/sops'], href: '/sops' },
  { ...SECTIONS.preparation, icon: ClipboardList, paths: ['/preparation'], href: '/preparation' },
  { ...SECTIONS.consent,   icon: Stamp,           paths: ['/consent'], href: '/consent' },
  { ...SECTIONS.anticoag,  icon: ShieldAlert,     paths: ['/anticoag-screening'], href: '/anticoag-screening' },
  { ...SECTIONS.roster,    icon: CalendarDays,    paths: ['/roster'], href: '/roster' },
  { ...SECTIONS.compliance, icon: Shield,         paths: ['/compliance', '/dias-compliance'], href: '/dias-compliance' },
  { ...SECTIONS.referrers, icon: Building2,       paths: ['/referrers'], href: '/referrers' },
];

const peopleTab = { ...SECTIONS.people, icon: Users, paths: ['/people'], href: '/people' };
const managementTab = { ...SECTIONS.management, icon: Settings2, paths: ['/management', '/dashboard'], href: '/management' };

export default function SectionNav() {
  const location = useLocation();
  const { user } = useAuth();
  const isPM = user?.role === 'admin' || user?.role === 'superuser';
  const allTabs = isPM ? [...tabs, peopleTab, managementTab] : tabs;

  const getActive = () => {
    for (const t of allTabs) {
      if (t.paths.some(p => location.pathname === p || location.pathname.startsWith(p + '/'))) return t.id;
    }
    return 'dashboard';
  };
  const active = getActive();

  return (
    <div className="bg-card border-b border-border" data-testid="section-nav">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center gap-1 py-1 overflow-x-auto">
          {allTabs.map(t => {
            const Icon = t.icon;
            const isActive = active === t.id;
            return (
              <Link
                key={t.id}
                to={t.href}
                data-testid={`section-tab-${t.id}`}
                className="flex items-center gap-2 px-4 py-2.5 text-sm font-medium rounded-lg whitespace-nowrap transition-all border"
                style={isActive
                  ? { backgroundColor: t.colorBg, color: t.color, borderColor: t.ring, fontWeight: 600 }
                  : { borderColor: 'transparent' }}
              >
                <Icon className="w-4 h-4" strokeWidth={1.5} style={{ color: isActive ? t.color : undefined }} />
                <span className={isActive ? '' : 'text-muted-foreground'}>{t.label}</span>
              </Link>
            );
          })}
        </div>
      </div>
    </div>
  );
}
